export default __webpack_public_path__ + "static/media/0S.de797ab0.png";